import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=ea5fdb86&scoped=true&"
import script from "./Qualification.vue?vue&type=script&lang=js&"
export * from "./Qualification.vue?vue&type=script&lang=js&"
import style0 from "./Qualification.vue?vue&type=style&index=0&id=ea5fdb86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5fdb86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VCard,VIcon,VSpeedDial})
